import { render } from "./SingleProject.vue?vue&type=template&id=c6053f84"
import script from "./SingleProject.vue?vue&type=script&lang=js"
export * from "./SingleProject.vue?vue&type=script&lang=js"

import "./SingleProject.vue?vue&type=style&index=0&id=c6053f84&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__